import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Form } from "react-bootstrap";
import _ from "lodash";
import cx from "classnames";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import styles from "./userprofile.module.scss";

import Password from "./password";
import { SuccessToast } from "components/Toast";

import ImageTools from "services/imagetools.service";

import { updateProfile } from "actions/users";

export default function UserprofileView() {
  const dispatch = useDispatch();

  const me = useSelector((state) => _.get(state, "users.me"));
  const updating = useSelector((state) => _.get(state, "users.updating"));
  const success = useSelector((state) => _.get(state, "users.succedded"));

  const [state, setState] = useState({
    icon: null,
    visible: false,
    error: null,
    firstName: me ? me.firstName : "",
    lastName: me ? me.lastName : "",
    title: me ? me.title : "",
    email: me ? me.email : "",
    workPhone: me ? me.workPhone : "",
    mobilePhone: me ? me.mobilePhone : "",
  });

  useEffect(() => {
    if (me) {
      setState(state => {
        return {
          ...state,
          firstName: me.firstName,
          lastName: me.lastName,
          title: me.title,
          email: me.email,
          workPhone: me.workPhone,
          mobilePhone: me.mobilePhone
        }
      })
    }
  }, [me]);

  useEffect(() => {
    if (success) {
      toast(
        <SuccessToast
          heading={`Success`}
          description={"Profile Updated Successfully"}
        />,
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
        }
      );
    }
  }, [success]);

  const uploadIconRef = React.createRef();

  const handleChange = (e) => {
    setState(state => {
      return {
        ...state,
        [e.target.name]: e.target.value,
        error: null
      }
    })
  };

  const handleUploadIcon = (e) => {
    ImageTools.resize(
      e.target.files[0],
      {
        width: 1024, // maximum width
        height: 1024, // maximum height
      },
      (blob) => {
        var reader = new FileReader();
        reader.onload = (e) => {
          setState(state => {
            return {
              ...state,
              icon: e.target.result
            }
          })
        };
        reader.readAsDataURL(blob);
      }
    );
  };

  const validateForm = () => {
    let errors = {};

    const { firstName } = state;

    if (!firstName || firstName.trim() === "") {
      errors.firstName = "Enter a valid first name";
    }

    return errors;
  }

  const handleSave = () => {

    const errors = validateForm();

    if (Object.keys(errors).length !== 0) {
      setState((state) => {
        return {
          ...state,
          errors: errors,
        };
      });

      return;
    }

    var request = {
      firstName: state.firstName,
      lastName: state.lastName,
      title: state.title,
      email: state.email,
      workPhone: state.workPhone,
      mobilePhone: state.mobilePhone,
      icon: state.icon,
    };

    dispatch(updateProfile(request));
  };

  const handleCancel = () => {
    setState(state => {
      return {
        ...state,
        firstName: me.firstName,
        lastName: me.lastName,
        title: me.title,
        email: me.email,
        workPhone: me.workPhone,
        mobilePhone: me.mobilePhone,
        error: null
      }
    })
  };

  const renderIcon = () => {
    if (state.icon) {
      return state.icon;
    }

    return _.get(me, "icon.thumbnail", null);
  };

  if (!me) {
    return null;
  }

  return (
    <>
      <section className={styles.content}>
        <header className={styles.header}>
          <aside className={styles.headerAside}>
            <h1 className={styles.storyboardHeading}>User Profile</h1>
            <span className={styles.storyboardSummary}>
              Let’s get you buckled up before lift off
            </span>
          </aside>
        </header>

        <div className={styles.userMain}>
          <div className={styles.profilePicture}>
            <span className={styles.heading}>Profile Picture</span>
            <div className={styles.userAvatar}>
              <img
                className={styles.userImage}
                src={renderIcon()}
                alt="/assets/images/profile/default_user_profile_background.png"
              />
              <div className={styles.uploadWrapper}>
                <Button variant="primary" className={styles.uploadButton}>
                  <i className={cx("cleverstory-upload")} />
                  <Form.Control
                    className={cx(styles.fileUpload)}
                    ref={uploadIconRef}
                    type="file"
                    onChange={handleUploadIcon}
                  />
                </Button>
              </div>
            </div>
          </div>
          <div className={styles.verticalLine}></div>

          <div className={styles.userProfileDetails}>
            <div className={styles.userProfileWrapper}>
              <span className={styles.heading}>User Details</span>
              <Form className={styles.detailForm} action="">
                <Form.Group className={styles.formCluster}>
                  <Form.Group className={styles.formGroup}>
                    <Form.Label className={styles.userFormLabel}>
                      First Name
                    </Form.Label>
                    <Form.Control
                      className={styles.userFormInput}
                      name="firstName"
                      value={state.firstName}
                      onChange={handleChange}
                      isInvalid={state.error}
                    />
                    <Form.Control.Feedback
                      type="invalid"
                      className={styles.error}
                    >
                      {state.error || "Please enter a valid name"}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className={styles.formGroup}>
                    <Form.Label className={styles.userFormLabel}>
                      Last Name
                    </Form.Label>
                    <Form.Control
                      className={styles.userFormInput}
                      name="lastName"
                      value={state.lastName}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Form.Group>
                <Form.Group className={styles.formCluster}>
                  <Form.Group className={styles.formGroupTwo}>
                    <Form.Label className={styles.userFormLabel}>
                      Email Address
                    </Form.Label>
                    <Form.Control
                      className={styles.userFormInput}
                      name="email"
                      value={state.email}
                      disabled
                    />
                  </Form.Group>
                  <Form.Group className={styles.formGroupThree}>
                    <Form.Label className={styles.userFormLabel}>
                      Title
                    </Form.Label>
                    <Form.Control
                      className={styles.userFormInput}
                      name="title"
                      value={state.title}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Form.Group>
                <Form.Group className={styles.formCluster}>
                  <Form.Group className={styles.formGroup}>
                    <Form.Label className={styles.userFormLabel}>
                      Work Phone
                    </Form.Label>
                    <Form.Control
                      className={styles.userFormInput}
                      name="workPhone"
                      value={state.workPhone}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  <Form.Group className={styles.formGroup}>
                    <Form.Label className={styles.userFormLabel}>
                      Mobile Phone
                    </Form.Label>
                    <Form.Control
                      className={styles.userFormInput}
                      name="mobilePhone"
                      value={state.mobilePhone}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Form.Group>
                <div className={styles.formButtons}>
                  <Button
                    className={styles.actionButton}
                    variant='primary'
                    onClick={handleSave}
                    disabled={updating}
                  >
                    {updating ? "Saving..." : "Save Changes"}
                  </Button>

                  <Button onClick={handleCancel} variant="secondary" className={styles.cancel}>
                    Cancel
                  </Button>
                </div>
              </Form>
            </div>
            <Password />
          </div>
        </div>
      </section>
    </>
  );
}
